export function showCustomHint(message, type = 'error', id) {
    const hintElement = document.createElement('div');

    hintElement.className = `custom-hint ${type}`;
    hintElement.id = id;
    hintElement.innerText = message;

    document.body.appendChild(hintElement);

    setTimeout(() => {
        hintElement.classList.add('show');
    }, 10); // Delay to allow CSS transition

    setTimeout(() => {
        hintElement.classList.remove('show');
        setTimeout(() => {
            document.body.removeChild(hintElement);
        }, 300); // Transition duration
    }, 5000); // Display duration
}
